.toolbar {
  display: flex;
  padding: 0.5rem 0;
  margin: 0.5rem 0;
}
@media all and (orientation: portrait) {
  .toolbar {
    width: 100%;
  }
}

.datatable {
  margin: 1rem;
  table-layout: fixed;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0JpbGxpbmdSZXBvcnQiLCJzb3VyY2VzIjpbImNsYXNzZXMubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0E7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFMRjtJQU1JOzs7O0FBSUo7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiXG4udG9vbGJhciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBhZGRpbmc6IDAuNXJlbSAwO1xuICBtYXJnaW46IDAuNXJlbSAwO1xuXG4gIEBtZWRpYSBhbGwgYW5kIChvcmllbnRhdGlvbjogcG9ydHJhaXQpIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxufVxuXG4uZGF0YXRhYmxlIHtcbiAgbWFyZ2luOiAxcmVtO1xuICB0YWJsZS1sYXlvdXQ6IGZpeGVkO1xufSJdfQ== */